<template>
    <div id='PlayItem'>
        <div class="main">
            <img class="img_s" :src="item.img">
            <div v-if="is_show_title" class="title"></div>
            <div class="name">{{ item.name }}</div>

            <div v-if="item.open" class="start_btn" @click="start_play"></div>
            <div v-else class="not_open_area">
                <span class="time">{{ item.time }}</span>
            </div>

        </div>
        <div v-if="item.pass" class="pass_btn"></div>


    </div>
</template>

<script>
import vue from "vue";
export default vue.component('PlayItem', {
    props: {
        item: Object,
    },
    data() {
        return {
        }
    },
    created() {
        // let image = new Image()
        // image.src = "//whhxparty.ehijoy.com/img/whhx_party/friend_invitation_act/game/plot_bg_1.png"
    },
    mounted() {

    },
    methods: {
        start_play() {
            this.$eventBus.$emit('start_play', this.item)
        }
    },
    computed: {
        is_show_title() { return this.item.has_title }


    }

})
</script>

<style scoped>
#PlayItem {
    position: relative;
    width: 433px;
    height: 402px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/item/item_bg.png') no-repeat center;
    background-size: 100% auto;
    font-family: 'xique';

}

.pass_btn {
    position: absolute;
    right: -18px;
    top: -10px;
    width: 124px;
    height: 66px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/item/pass_btn.png') no-repeat center;
    background-size: 100% auto;
}

.main {
    /* border: 1px solid red; */
    position: relative;
    width: 425px;
    height: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    margin: 4px 0 0 13px;

}

.title {
    position: absolute;
    width: 409px;
    height: 40px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guest/item/title_extra.png') no-repeat center;
    background-size: 100% auto;
}

.img_s {
    width: 409px;
    height: 189px;
    object-fit: cover;
}

.name {
    height: 50px;
    font-size: 30px;
    color: #643b26;
    margin-top: 19px;
}

.start_btn {
    width: 312px;
    height: 83px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/item/start_btn.png') no-repeat center;
    background-size: 100% auto;
    margin-top: 10px;

}

.not_open_area {
    width: 289px;
    height: 99px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/item/not_open_bg.png') no-repeat center;
    background-size: 100% auto;
    font-size: 42px;
    color: #a42423;
    display: flex;
    flex-flow: column;
    align-items: center;
}

.not_open_area .time {
    margin-top: 10px;
}
</style>